export default function Features() {
    return (
      <section id="features" className="features">
        <div className="features-title-container">
          <h2 className="section-title" style={{color: 'white'}}>Magical Features</h2>
        </div>
        
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">✨</div>
            <h3 className="feature-title">Living Portrait</h3>
            <p>Your personalized portrait comes alive with realistic movements, responding to your presence just like the magical paintings at your favorite castle.</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">✨</div>
            <h3 className="feature-title">Intelligent Conversation</h3>
            <p>Engage in meaningful conversations with your portrait, which learns your preferences and personality over time.</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">✨</div>
            <h3 className="feature-title">Personalized Experience</h3>
            <p>Ask for the news, weather, or extend access to your favoriteapps.</p>
          </div>
        </div>
  
        <style jsx>{`
          .features {
            
            background-size: 100% 100%;
            animation: gradientFlow 15s ease infinite;
            color: white;
            position: relative;
            font-weight: 200;
            padding: 2rem 2rem;
            text-align: center;
            overflow: hidden;
            cursor: default;
          }
          
          @keyframes gradientFlow {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
          
          .features::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            pointer-events: none;
          }
          
          .section-title {
            font-family: serif;
            font-size: 2rem;
            text-align: center;
            margin-top: -10rem;
            position: relative;
            display: inline-block;
            font-weight: 600;
            color: #fff;
          }
          
          .features-title-container {
            text-align: center;
           
          }
          
          .section-title::after {
            content: '';
            position: absolute;
            width: 80px;
            height: 4px;
            background: #ffd700;
            bottom: -15px;
            left: 50%;
            transform: translateX(-50%);
          }
          
          .features-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
            gap: 2rem;
            max-width: 1200px;
            margin: 0 auto;
          }
          
          .feature-card {
            background: rgba(255, 255, 255, 0.05);
            backdrop-filter: blur(10px);
            border-radius: 15px;
            padding: 2.5rem;
            box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
            transition: all 0.3s ease;
            position: relative;
            overflow: hidden;
            z-index: 1;
            text-align: left;
            color:rgb(255, 255, 255);;
          }
          
          .feature-card::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 0;
            background: linear-gradient(135deg,rgb(24, 16, 8) 0%, #3a2a5e 100%);
            z-index: -1;
            transition: all 0.3s ease;
          }
          
          .feature-card:hover {
            transform: translateY(-10px);
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
            color: #fff;
          }
          
          .feature-card:hover::before {
            height: 100%;
          }
          
          .feature-card:hover .feature-icon {
            background: #A16207;
            color: #000;
          }
          
          .feature-icon {
            width: 70px;
            height: 70px;
            border-radius: 50%;
            background: rgba(106, 58, 178, 0.1);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 2rem;
            color: #6a3ab2;
            margin-bottom: 1.5rem;
            transition: all 0.3s ease;
          }
          
          .feature-title {
            font-size: 1.5rem;
            margin-bottom: 0.5rem;
            font-weight: 400;
            font-family: serif;
            color:rgb(255, 255, 255);
          }
          
          @media (max-width: 768px) {
            .features-grid {
              grid-template-columns: 1fr;
            }
            
            .section-title {
              font-size: 1.5rem;
            }
          }
        `}</style>
      </section>
    );
  } 